import { ProfilePage } from '@/components/members/profile-page'

export function MemberProfile() {
  return <ProfilePage />
}
